module.exports = __webpack_public_path__ + "static/logo_big_white-745b4c28c0d5f86125df88ac11ccec0e.png";